import { HelpMessage } from 'utils/constants'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'

export const CreateOrganizationModalBody: React.FC = () => {
  return (
    <>
      <NameFormItem help={HelpMessage.DesignSubmittals.Organizations.Name} />
      <DescriptionFormItem entityName="Organization" />
    </>
  )
}
